import React from "react";
import Modal from "../shared/Modal";

const AIInsightModal = ({
  article,
  summary,
  open,
  onClose,
  onAddToResearch,
}) => {
  if (!open || !article) return null;
  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      width="large"
    >
      <div className="p-6">
        <div className="flex justify-between items-start mb-4">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">AI Summary</h2>
          {onAddToResearch && (
            <button
              onClick={() => onAddToResearch(article)}
              className="p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 flex items-center text-green-600"
            >
              <span role="img" aria-label="Add">➕</span>
              <span className="text-sm ml-1">Add to R&D</span>
            </button>
          )}
        </div>
        <div className="mb-4">
          <h3 className="text-sm font-medium text-gray-900 dark:text-gray-100 mb-2">Article:</h3>
          <p className="text-[15px] text-gray-900 dark:text-gray-100 font-medium">{article.title}</p>
          <p className="text-[13px] text-gray-600 dark:text-gray-400 mt-1">
            {article.source} • {article.time}
          </p>
        </div>
        <div className="space-y-4">
          <div>
            <h3 className="text-sm font-medium text-gray-900 dark:text-gray-100 mb-2">Key Points:</h3>
            <ul className="list-disc list-inside space-y-1">
              {summary && summary.keyPoints ? (
                summary.keyPoints.map((point, idx) => (
                  <li key={idx} className="text-[14px] text-gray-700 dark:text-gray-300">
                    {point}
                  </li>
                ))
              ) : (
                <li className="text-[14px] text-gray-700 dark:text-gray-300">No summary available.</li>
              )}
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-medium text-gray-900 dark:text-gray-100 mb-2">
              Market Sentiment:
            </h3>
            <p className="text-[14px] text-gray-700 dark:text-gray-300">
              {summary && summary.sentiment ? summary.sentiment : "N/A"}
            </p>
          </div>
          <div>
            <h3 className="text-sm font-medium text-gray-900 dark:text-gray-100 mb-2">
              Potential Market Impact:
            </h3>
            <p className="text-[14px] text-gray-700 dark:text-gray-300">
              {summary && summary.marketImpact ? summary.marketImpact : "N/A"}
            </p>
          </div>
        </div>
        <div className="mt-6 flex justify-end">
          <button
            onClick={onClose}
            className="px-3 py-1.5 text-[14px] text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-md"
          >
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default AIInsightModal;
